import dayjs from 'dayjs';
import {
  NEW,
  SCHEDULING,
  QUEUEING,
  PENDING_SCHEDULING,
  DRIVER_CANCELLED,
  SENDER_CANCELLED,
  OPERATOR_CANCELLED,
  PENDING_PICKUP,
  PENDING_DROP_OFF,
  COMPLETED,
  DROPPING_OFF,
  FAILED_DELIVERY,
  RETURNED,
} from 'constants/new-order-status';

export const isAllocatingStatus = status => [NEW, SCHEDULING].includes(status);

export const isPendingScheduleStatus = status =>
  [QUEUEING, PENDING_SCHEDULING].includes(status);

export const isReturnedStatus = status => status === RETURNED;
export const isCompletedStatus = status => status === COMPLETED;

export const isFailedStatus = status => status === FAILED_DELIVERY;

export const isDropoffStatus = status =>
  [PENDING_DROP_OFF, DROPPING_OFF].includes(status);

export const isCancelledStatus = status =>
  [DRIVER_CANCELLED, SENDER_CANCELLED, OPERATOR_CANCELLED].includes(status);

export const isPendingStatus = status =>
  [PENDING_PICKUP, PENDING_DROP_OFF].includes(status);

export const isFinishedStatus = status =>
  isCompletedStatus(status) ||
  isReturnedStatus(status) ||
  isFailedStatus(status) ||
  isCancelledStatus(status);

/**
 *
 * @param {number} target
 * @param {number} hours Number of hours passed
 * @param {{now: any}} options
 * @returns {boolean}
 */
export const isAfterHours = (target, hours, options = { now: dayjs() }) => {
  const { now } = options;
  const diffInHours = now.diff(dayjs(target), 'hours');

  return diffInHours >= hours;
};
